import { render, staticRenderFns } from "./schedule-header.component.vue?vue&type=template&id=33970e20&scoped=true&"
import script from "./schedule-header.component.vue?vue&type=script&lang=ts&"
export * from "./schedule-header.component.vue?vue&type=script&lang=ts&"
import style0 from "./schedule-header.component.vue?vue&type=style&index=0&id=33970e20&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33970e20",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VBtn,VCheckbox})
